import axios from 'axios';
import { satisfies } from 'semver';
import { API_COMPATIBLE_VERSION_RANGE } from '..';
import { unSupportedAuthAPIVersion } from '../errors';
import { defaultConfig } from '../config/DefaultConfig';
import { pipe } from '../utils/fp.utils';
export function validateConfig(config) {
    return pipe(validatePropsConfig, validateCompatibility)(config);
}
export function validatePropsConfig(customConfig) {
    // clone
    const config = { ...defaultConfig, ...customConfig };
    if (config.url && config.url.substr(-1) === '/') {
        config.url = config.url.substr(0, -2);
    }
    config.secure =
        config.url.substr(0, 8) === 'https://' ||
            config.port === 443 ||
            config.secure;
    if (config.path) {
        let parts = config.path.split('/');
        if (parts[0] !== '') {
            parts.unshift('');
        }
        if (parts[parts.length - 1] === '') {
            parts.pop();
        }
        config.path = parts.join('/');
    }
    else {
        config.path = '/';
    }
    return config;
}
export async function validateCompatibility(config) {
    const url = `${fullUrl(config)}/version`;
    const response = await axios.get(url);
    const { version } = response.data;
    const isSatisfiedVersion = satisfies(version, API_COMPATIBLE_VERSION_RANGE);
    if (!isSatisfiedVersion) {
        console.error(unSupportedAuthAPIVersion(version, API_COMPATIBLE_VERSION_RANGE));
    }
    return config;
}
export function fullUrl(config) {
    if (config.url !== '') {
        return `${config.secure ? `https://` : `http://`}${config.url}${[443, 80, undefined].indexOf(config.port) > -1 ? `:${config.port}` : ``}${config.path}`;
    }
    else if (config.url === '' && config.path) {
        return config.path;
    }
    return '';
}
